import { isNumber, capitalize } from "lodash";
import React, { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import ClassificationIcon from "./ClassificationIcon";
import { classificationByValues } from "../lib/enums/ThreatStatusEnum";

interface IThreatStatusLabelProps {
  threatStatus?: string | number;
  showOrb?: boolean;
  showColor?: boolean;
  labelText?: string;
  labelPrefix?: string;
  url?: string;
  openNewTab?: boolean;
  showTitle?: boolean;
  riskScore?: number;
  className?: string;
  onClick?: () => void;
}

const ThreatStatusLabel: FunctionComponent<IThreatStatusLabelProps> = ({
  threatStatus: classification = -1,
  showOrb = true,
  showColor = false,
  showTitle,
  labelText = "",
  labelPrefix = "",
  url = "",
  openNewTab = false,
  riskScore,
  className = "",
  onClick
}) => {
  let label: string;
  if (isNumber(classification)) {
    label = classificationByValues[classification];
  } else {
    label = classification;
  }
  const classNameDisplay = `${
    showColor ? `threat-link--${label?.toLowerCase()}` : ""
  } ${className || ""}`;
  const labelContent = (
    <>
      {labelPrefix.trim() && <span>{labelPrefix}</span>}
      {showOrb && (
        <ClassificationIcon
          classification={classification}
          riskScore={riskScore}
        />
      )}
      {labelText || capitalize(label)}
    </>
  );

  return url ? (
    <Link
      to={url}
      className={classNameDisplay}
      target={openNewTab ? "_blank" : undefined}
    >
      {labelContent}
    </Link>
  ) : (
    <span
      {...(showTitle ? { title: labelText || capitalize(label) } : {})}
      onClick={onClick}
      className={classNameDisplay}
    >
      {labelContent}
    </span>
  );
};

export default ThreatStatusLabel;
